import axios from "axios";

const API = axios.create({ 
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api" 
});

// Attach JWT token to every request automatically
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ── Auth ──────────────────────────────────────
export const registerUser = (data) => API.post("/auth/register", data);
export const loginUser = (data) => API.post("/auth/login", data);
export const getMe = () => API.get("/auth/me");

// ── Shops ─────────────────────────────────────
export const getShops = (params) => API.get("/shops", { params });
export const getShopById = (id) => API.get(`/shops/${id}`);
export const createShop = (data) => API.post("/shops", data);
export const updateShop = (id, data) => API.put(`/shops/${id}`, data);
export const addService = (shopId, data) => API.post(`/shops/${shopId}/services`, data);

// ── Bookings ──────────────────────────────────
export const getAvailableSlots = (shopId, date, serviceId) =>
  API.get(`/bookings/available-slots?shop_id=${shopId}&date=${date}&service_id=${serviceId}`);
export const createBooking = (data) => API.post("/bookings", data);
export const getMyBookings = () => API.get("/bookings/my");
export const getShopBookings = (shopId, date) => API.get(`/bookings/shop/${shopId}`, { params: { date } });
export const updateBookingStatus = (id, status) => API.patch(`/bookings/${id}/status`, { status });

// ── Payments ──────────────────────────────────
export const getPlans = () => API.get("/payments/plans");
export const createOrder = (data) => API.post("/payments/create-order", data);
export const verifyPayment = (data) => API.post("/payments/verify", data);
export const getSubscription = (shopId) => API.get(`/payments/subscription/${shopId}`);

// ── Reviews ───────────────────────────────────
export const submitReview = (shopId, data) => API.post(`/shops/${shopId}/reviews`, data);

// ── Coupons ───────────────────────────────────
export const validateCoupon = (data) => API.post("/coupons/validate", data);

// ── Home Services ──────────────────────────────
export const getHomeServices = (shopId) => API.get(`/home-services/shop/${shopId}`);
export const addHomeService = (data) => API.post("/home-services", data);
export const updateHomeService = (id, data) => API.put(`/home-services/${id}`, data);
export const deleteHomeService = (id) => API.delete(`/home-services/${id}`);
export const toggleHomeService = (shopId, enabled) => API.patch(`/home-services/toggle/${shopId}`, { enabled });
export const createHomeOrder = (data) => API.post("/home-services/book/create-order", data);
export const confirmHomeBooking = (data) => API.post("/home-services/book/confirm", data);
export const getMyHomeBookings = () => API.get("/home-services/bookings/my");
export const getShopHomeBookings = (shopId) => API.get(`/home-services/bookings/shop/${shopId}`);
export const updateHomeBookingStatus = (id, status) => API.patch(`/home-services/bookings/${id}/status`, { status });

export default API;
